module.exports = {
  theme: {
    extend: {
      colors: {
        primary: '#7B3FE4',
        purple: {
          50: '#EAE0FB',
          100: '#DDCEF8',
          200: '#C5AAF3',
          300: '#AC87EE',
          400: '#9463E9',
          500: '#7B3FE4',
          600: '#5D1DCE',
          700: '#47169D',
          800: '#310F6C',
          900: '#1A083A'
        }
      }
    }
  }
};
